import React,{Component} from 'react';
import { ref } from '../config/constants'
import {formatPrice} from '../helpers/helpers'

class QBendedEdit extends Component{
    constructor(){
        super();
        this.handleChange = this.handleChange.bind(this)
        this.handleTotal = this.handleTotal.bind(this)
        this.handleDimension = this.handleDimension.bind(this)
        this.handleDiscount =this.handleDiscount.bind(this)
        this.delete =this.delete.bind(this)
        this.state = {
            product :{},
            total : 0,
            BendedPrice : {},
            price : 0,
            productNumber : 0,
            productDimension:"",
            productThickness:"",
            pretotal : 0,
            discount : 0      
            
        }
    }

    componentWillMount(){
        let prodData = ref.child("Products").child(this.props.product.productId)
            prodData.on("value",function(data){
                
                    this.setState({
                        product : data.val()
                    })
                    //this.props.setProduct(data.val(),this.props.index)
                    
            }.bind(this))
           
             
            this.setState({
                total : this.props.product.productTotal,
                pretotal : this.props.product.productTotal
             })  
            this.setState({
                price : this.props.product.productPrice
             })  
            this.setState({
                productNumber : (this.props.product.productNumber)?this.props.product.productNumber:0
             })  
            this.setState({
                productDimension : this.props.product.productDimension
             })
            this.setState({
                productThickness : this.props.product.productThickness
             })
            this.setState({
                discount : this.props.product.productDiscount
            })    
        let category = ref.child("BendedPrice").orderByChild('status').equalTo('Active');
            category.on("value", function(snap){
                this.setState({
                    BendedPrice : snap.val()
                })
            }.bind(this))     
                                              
    }

    
    
    handleChange(e){
        this.setState({
            productThickness : e.target.value
        })
       
        let product = this.state.product
        var labor = 0
            if(this.productThickness.value ==="price_4MM"){
                labor = product.laborPrice_4MM
                this.setState({
                    thickness : "price_4MM"
                })
                
            }
            if(this.productThickness.value ==="price_5MM"){
                labor = product.laborPrice_5MM
                this.setState({
                    thickness : "price_5MM"
                })
                
            }
            if(this.productThickness.value ==="price_6MM"){
                labor = product.laborPrice_6MM
                this.setState({
                    thickness : "price_6MM"
                })
                
            }
            if(this.productThickness.value ==="price_8MM"){
                labor = product.laborPrice_8MM
                this.setState({
                    thickness : "price_8MM"
                })
                
            }
        let update = {
                ...product,
                laborPrice : labor,
                price : this.state.product[e.target.value]
            }

        this.setState({
            product : update,
            price : this.state.product[e.target.value]
        })

        if(this.productNumber.value){

            let total = this.productNumber.value * this.state.product[e.target.value]
                total= total.toFixed(2)

                this.setState({
                    total,
                    pretotal : total
                })
            }

    }

    handleDimension(e){
        this.setState({
            productDimension :e.target.value
        })
        if(this.productDimension.value ){
            let list = this.state.BendedPrice[this.productDimension.value]
            let product = this.state.product
            //let total = list[this.productThickness.value] * this.productNumber
            let update = {
                ...product,
                price : list[this.productThickness.value],
                price_4MM : list.price_4MM,
                price_5MM : list.price_5MM,
                price_6MM : list.price_6MM,
                price_8MM : list.price_8MM,
            }


            this.setState({
            product : update
            })
            this.setState({
                price : list[this.productThickness.value]
            })

            if(this.productNumber.value){

                let total = list[this.productThickness.value] * this.productNumber.value
                    total = total.toFixed(2)
                    this.setState({
                        total,
                        pretotal : total
                    })
            }
            
        }
    }

    handleTotal(e){
        if(this.state.discount){
            let total = this.productPrice.value * e.target.value
            let discount = this.state.discount/100            
            total= total.toFixed(2)
            let dis = total -(total * discount)
            this.setState({
                total: dis,
                pretotal :total
            })

            let product = this.state.product
             let update = {
                    ...product,
                    number :e.target.value
                }

            this.setState({
                product : update
            })
            this.setState({
                productNumber : e.target.value
            })

        }else{
            let total = this.productPrice.value * e.target.value
            total= total.toFixed(2)
            this.setState({
                total,
                pretotal :total
            })

            let product = this.state.product
             let update = {
                    ...product,
                    number :e.target.value
                }

            this.setState({
                product : update
            })
            this.setState({
                productNumber : e.target.value
            })
        }
        
    }

    handleDiscount(e){
        
        let total = this.state.price * this.state.productNumber
        let discount = e.target.value/100
        let dis = total - (total * discount)
        
            this.setState({
                total : dis
            }) 
            this.setState({
                discount : e.target.value
            })
           
    }

    delete(index){
        this.props.remove(index)
        this.props.removeTotal(index)
    }

   
    componentDidUpdate(prevProps,prevState){
        if(prevState.product !== this.state.product){
           //this.props.setProductsLabor(this.state.product,this.props.index,this.state.productNumber)
           if(this.productThickness.value=="price_4MM"){
                this.props.setProductsLabor(this.props.index,this.state.product.name,this.state.productNumber,this.state.product.laborPrice_4MM,0,this.state.product.unit)
            }
            if(this.productThickness.value=="price_5MM"){
                this.props.setProductsLabor(this.props.index,this.state.product.name,this.state.productNumber,this.state.product.laborPrice_5MM,0,this.state.product.unit)
            }
            if(this.productThickness.value=="price_6MM"){
                this.props.setProductsLabor(this.props.index,this.state.product.name,this.state.productNumber,this.state.product.laborPrice_6MM,0,this.state.product.unit)
            }
            if(this.productThickness.value=="price_8MM"){
                this.props.setProductsLabor(this.props.index,this.state.product.name,this.state.productNumber,this.state.product.laborPrice_8MM,0,this.state.product.unit)
            }
           this.props.getTotal(this.props.index,this.state.total)
        }

        if(prevState.total !== this.state.total){
            this.props.getTotal(this.props.index,this.state.total)
        }

        if(prevState.pretotal !== this.state.pretotal){
            if(this.state.discount > 0){

                let total = this.state.pretotal
                let discount = this.productDiscount.value/100
                let dis = total - (total * discount)
            
                this.setState({
                    total : dis
                })
            }
        }
    }

    render() {       
            
        return (
            
                    <tr>
                        <td>
                            <div className="row nomarginLR">
                                <div className="col-lg-7 col-md-5 nopaddingLR">
                                    <p className="text-uppercase">{this.state.product.name}</p>
                                </div>
                                <div className="col-lg-5 col-md-3 nopaddingLR">
                                    <button type="button" className="btn btn-sm btn-danger" onClick={()=>this.delete(this.props.index)}><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                                </div>
                            </div>
                         
                            <input type="hidden" className="form-control" name="productName" ref={input => this.productName = input} value={this.state.product.name}/>
                            <input type="hidden" className="form-control" name="category" ref={input => this.category = input} value="Bended Accessories"/>
                            <input type="hidden" className="form-control" name="productId" ref={input => this.productId = input} value={this.props.product.productId}/>
                        </td>

                        <td>
                            <select className="form-control" name="productDimension" ref={input => this.productDimension = input} value={this.state.productDimension} onChange={this.handleDimension} >
                                <option></option>
                                { 
                                    this.state.BendedPrice &&
                                    Object.keys(this.state.BendedPrice).map(function (key){
                                        let list = this.state.BendedPrice[key]
                                        return <option value={key} key={key}> {list.dimension} </option>
                                   }.bind(this))
                                }

                            </select>
                        </td>
                        
                        <td>
                            <select className="form-control" name="productThickness" ref={input => this.productThickness = input} value={this.state.productThickness} onChange={this.handleChange}>
                                <option>Select Thickness</option>
                                <option value="price_4MM">0.4MM</option>
                                <option value="price_5MM">0.5MM</option>
                                <option value="price_6MM">0.6MM</option>
                                <option value="price_8MM">0.8MM</option>
                            </select>
                        </td>
                        <td>
                            
                                <input type="text" className="form-control" name="productNumber" ref={input => this.productNumber = input}  value={this.state.productNumber} onChange={this.handleTotal} />
                            
                        </td>
                         <td>
                            <p>{`${this.state.product.unit}`}
                                <input type="hidden" className="form-control" name="productUnit" ref={input => this.productUnit = input} value={this.props.product.productUnit} />
                            </p>
                        </td>
                        
                        <td>
                            <p>{this.state.price}
                                <input type="hidden" className="form-control" name="productPrice" ref={input => this.productPrice = input} value={this.state.price} />
                            </p>
                        </td>

                        <td>
                            <p>{`/${this.state.product.unit}`}
                                <input type="hidden" className="form-control" name="productUnit" ref={input => this.productUnit = input} value={this.state.product.unit} />
                            </p>
                        </td>
                        
                        <td>
                           <input type="text" className="form-control"  name="productDiscount" ref={input => this.productDiscount = input} value={this.state.discount} onChange={this.handleDiscount} />
                        </td>
                        
                        <td>
                            <p>{formatPrice(this.state.total)}</p>
                            <input type="hidden" className="form-control" name ="productTotal" ref={input => this.productTotal = input} value={this.state.total} />
                        </td>
                    </tr>
                
 
        );
    }
}

export default  QBendedEdit;


// WEBPACK FOOTER //
// ./src/components/QBendedEdit.js